﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { IDiscNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { PrimitiveMeshNode } from './primitive-mesh-node';

@Kb3dModel({
    token: Token.DiscNode,
})
export class DiscNode extends PrimitiveMeshNode implements IDiscNode {
    public constructor() {
        super();
    }
    public radius: number;
    public tessellation: number;
}

export function isDiscMesh(node: Kb3dObject): node is DiscNode {
    return instanceOf(node, Token.DiscNode);
}
